import { Col, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useEffect } from "react";
import { useUserIDs } from "./useTelecallerIDUpdation";
import Select from "react-select";

const UpdationModal = ({ show, onClose, onTelecalledIDUpdate, refNo }) => {
  const { isLoading, fetchUserIDs, userIDs, error } = useUserIDs();

  const loggedInUserId = localStorage.getItem("userId");

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      userId: "",
    },
  });

  useEffect(() => {
    if (refNo) {
      setValue("refNo", refNo);
    }
  }, [refNo, setValue]);

  const exists = userIDs.includes(loggedInUserId);
  useEffect(() => {
    if (userIDs.length && loggedInUserId) {
      setValue("userId", exists ? loggedInUserId : "");
    }
  }, [loggedInUserId, setValue, userIDs.length, exists, show]);

  const userIDOptions = userIDs.map((userID) => {
    return {
      value: userID,
      label: userID,
    };
  });

  const onSubmit = (data) => {
    onTelecalledIDUpdate(data);
  };

  return (
    <Modal
      className="idu-modal"
      show={show}
      onHide={onClose}
      centered
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>Update User ID</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <Row>
            <Col xs={12} md={6}>
              <label className="d-block idu-label" htmlFor="">
                Client Reference Number
              </label>
              <input
                className="idu-input w-100"
                type="text"
                disabled
                {...register("refNo", {
                  required: "Client Reference Number is required",
                })}
              />
              {errors?.refNo?.message && (
                <p className="idu-error-text">{errors.refNo.message}</p>
              )}
            </Col>

            <Col xs={12} md={6}>
              <label className="d-block idu-label" htmlFor="">
                User ID
              </label>

              <Controller
                name="userId"
                control={control}
                rules={{ required: "User ID is required" }}
                render={({ field }) => {
                  const selectedOption = userIDOptions.find(
                    (opt) => opt.value === field.value,
                  );

                  return (
                    <Select
                      {...field}
                      value={selectedOption || null}
                      placeholder="Select"
                      classNamePrefix="idu-select"
                      options={userIDOptions}
                      onChange={(selected) =>
                        field.onChange(selected ? selected.value : "")
                      }
                      isLoading={isLoading}
                      isDisabled={isLoading}
                    />
                  );
                }}
              />
              {errors?.userId?.message && (
                <p className="idu-error-text">{errors.userId.message}</p>
              )}
              {error && (
                <button
                  type="button"
                  style={{
                    backgroundColor: "transparent",
                    fontSize: "1.2rem",
                  }}
                  onClick={fetchUserIDs}
                >
                  Try Again
                </button>
              )}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <button className="idu-btn-outline" type="button" onClick={onClose}>
            CANCEL
          </button>
          <button className="idu-btn-primary">UPDATE</button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default UpdationModal;
